import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddVideo from "../../../containers/admin/videos/models/add-video";
import AddVideoFiels from "../../../containers/admin/videos/models/add-video-fiels";
import VideoChaptersModal from "../../../containers/admin/videos/models/video-chapters";
import SearchBar from "../../../containers/admin/videos/searchbar";
import VideosTable from "../../../containers/admin/videos/table";
import { getAllVideosRequest } from "../../../modules/admin-modules/videos/Actions";
import { Button, Spinner } from "@chakra-ui/react";
import { fixViewsCountRequest } from "../../../modules/admin-modules/videos/Actions";
import { getAllAdminSectionsRequest } from "../../../modules/admin-modules/sections/Actions";

const Videos = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const user = useSelector((state) => state.user.userData);
  const videos = useSelector((state) => state.videos.videos);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [selectedSectionIds, setSelectedSectionIds] = useState([]);

  useEffect(() => {
    dispatch(getAllVideosRequest());
    dispatch(getAllAdminSectionsRequest());
  }, []);

  const filteredVideos = useMemo(() => {
    if (!selectedSectionIds.length) return videos;

    return videos?.filter((video) =>
      selectedSectionIds.some(
        (sectionId) => String(sectionId) === String(video?.chapter?.section_id)
      )
    );
  }, [videos, selectedSectionIds]);

  const fixViewsCount = () => {
    dispatch(fixViewsCountRequest());
  }

  const isSuperAdmin = user?.role && Array.isArray(user.role) && user.role[0]?.name === "Super Admin";

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        selectedSectionIds={selectedSectionIds}
        setSelectedSectionIds={setSelectedSectionIds}
        videoCount={filteredVideos?.length ?? 0}
      />
      {isSuperAdmin && (
        <Button 
          onClick={fixViewsCount}
          colorScheme="yellow"
          size="sm"
          mb={4}
        >
          Fix Views Count
        </Button>
      )}
      <VideosTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        videos={filteredVideos}
      />
      <AddVideo
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
      <AddVideoFiels isAdd={isAdd} data={selectedData} />
      <VideoChaptersModal data={selectedData} />
    </Layout>
  );
};

export default Videos;
